import { render, staticRenderFns } from "./CheckpointLevelBadge.vue?vue&type=template&id=4352b225"
import script from "./CheckpointLevelBadge.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckpointLevelBadge.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CheckpointLevelBadge.vue?vue&type=style&index=0&id=4352b225&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports